export const setVariablesTextareaContent = (variables: Object) => {
  let result: string = '';
  Object.entries(variables).forEach(([key, value]) => {
    typeof value === 'string' || value instanceof String
      ? (result += `${key}='${value}'\n`)
      : (result += `${key}=${value}\n`);
  });
  return result;
};
